import React from 'react';
import styled from 'styled-components';
import { Fill } from '../ui/Fill';
import { Colors } from './../ui';
import { Sebastian } from './canvas/ui/Sebastian';

const Frame = styled(Fill)`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F9FAFC;

    ${Sebastian} {
        transform: scaleX(-1);
    }

    span {
        position: relative;
        display: inline-block;
        color: ${Colors.positive};
        font-weight: 500;
        font-size: 1.5rem;
    }
`;

export const AppLoading = () => {
    return <Frame>
        <span>Just a moment...</span>
    </Frame>;
};
